import "../i18n.mjs";
import { countryLabelKey as e } from "./countryLabelKey.mjs";
import { useCallback as t } from "react";
import { useTranslation as n } from "react-i18next";
//#region src/hooks/useTrCountry.ts
var r = () => {
	let { t: r } = n("countries");
	return t((t) => {
		let n = e(t);
		return n ? r(n, { defaultValue: n }) : "";
	}, [r]);
};
//#endregion
export { r as useTrCountry };
